export const getXAxis = (oneData) => Number(oneData.x);
export const getYAxis = (oneData) => Number(oneData.y);
